// libraries
import { BarChart } from "@mui/x-charts"

// providers
import { useAuthDataContext } from "@/_providers/Auth"
import { trans } from "@/_providers/Translation"

export default function RemainingMessagesChart() {
  const { partner } = useAuthDataContext()
  const viberCount = partner()?.viber_count || 0
  const whatsappCount = partner()?.whatsapp_count || 0
  const smsCount = partner()?.sms_count || 0

  const chartData = [
    {
      type: "SMS",
      count: smsCount,
    },
    {
      type: "Viber",
      count: viberCount,
    },
    {
      type: "WhatsApp",
      count: whatsappCount,
    },
  ]

  return (
    <div className="messages-chart">
      <div className="head">
        <h3>Оставащи съобщения</h3>
        <button
          className="button-add button-small"
          onClick={() => {
            window.open("https://eusystem.eu/sms-packets", "_blank")
          }}
        >
          {trans("buttons.getMessagesPackage")}
        </button>
      </div>
      <hr />
      <BarChart
        dataset={chartData}
        xAxis={[
          {
            scaleType: "band",
            dataKey: "type",
          },
        ]}
        series={[
          {
            dataKey: "count",
            label: "Брой",
            color: "#43A5FF",
          },
        ]}
        height={300}
        borderRadius={8}
        slotProps={{
          legend: { hidden: true },
        }}
      />
    </div>
  )
}
